import { Pessoa } from "../../cad/pessoa/pessoa";


export class Representante extends Pessoa{
    codigoRepresentante: number;
    codigoSupervisorRepresentante: number;
    indSituacao: boolean
}
